<script>
import { mapGetters } from 'vuex';
import PortalSwitch from './PortalSwitch.vue';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper';
import { PORTAL_CREATE_PERMISSIONS } from 'dashboard/constants/permissions';

const NEW_PORTAL_ROUTE = 'new_portal_information';

export default {
  components: {
    PortalSwitch,
  },
  props: {
    portals: {
      type: Array,
      default: () => [],
    },
    activePortalSlug: {
      type: String,
      default: '',
    },
    activeLocale: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
    }),
    canCreatePortal() {
      return hasPermissions(
        PORTAL_CREATE_PERMISSIONS,
        getUserPermissions(this.currentUser, this.accountId)
      );
    },
  },

  methods: {
    closePortalPopover() {
      this.$emit('closePopover');
    },
    openPortalPage() {
      this.closePortalPopover();
      this.$router.push({
        name: 'list_all_portals',
      });
    },
    openNewPortalPage() {
      this.closePortalPopover();
      this.$router.push({
        name: NEW_PORTAL_ROUTE,
      });
    },
    fetchPortalAndItsCategories() {
      this.$emit('fetchPortal');
    },
  },
};
</script>

<template>
  <div
    v-on-clickaway="closePortalPopover"
    class="absolute overflow-y-scroll max-h-[96vh] p-4 bg-white dark:bg-slate-800 rounded-md shadow-lg max-w-[30rem] z-[1000]"
  >
    <header>
      <div class="flex items-center justify-between mb-4">
        <h2 class="text-lg text-slate-800 dark:text-slate-100">
          {{ $t('HELP_CENTER.PORTAL.POPOVER.TITLE') }}
        </h2>
        <div>
          <woot-button
            variant="smooth"
            color-scheme="secondary"
            icon="settings"
            size="small"
            @click="openPortalPage"
          >
            {{ $t('HELP_CENTER.PORTAL.POPOVER.PORTAL_SETTINGS') }}
          </woot-button>
          <woot-button
            variant="clear"
            color-scheme="secondary"
            icon="dismiss"
            size="small"
            @click="closePortalPopover"
          />
        </div>
      </div>
      <p class="mt-2 text-xs text-slate-600 dark:text-slate-300">
        {{ $t('HELP_CENTER.PORTAL.POPOVER.SUBTITLE') }}
      </p>
    </header>
    <div>
      <PortalSwitch
        v-for="portal in portals"
        :key="portal.id"
        :portal="portal"
        :active-portal-slug="activePortalSlug"
        :active-locale="activeLocale"
        :active="portal.slug === activePortalSlug"
        @openPortalPage="closePortalPopover"
        @fetchPortal="fetchPortalAndItsCategories"
      />
    </div>
    <div
      v-if="canCreatePortal"
      class="pt-3 border-0 border-t border-solid border-slate-100 dark:border-slate-600"
    >
      <woot-button
        variant="clear"
        color-scheme="secondary"
        icon="add"
        size="small"
        class-names="w-full"
        @click="openNewPortalPage"
      >
        {{ $t('HELP_CENTER.PORTAL.NEW_BUTTON') }}
      </woot-button>
    </div>
  </div>
</template>
